import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1f1f1f', // texto escuro
      contrastText: '#fff', // contraste para botões primários
    },
    secondary: {
      main: '#f78b00', // laranja vibrante
      contrastText: '#fff',
    },
    background: {
      default: '#F4F6F8', // fundo geral da página
      paper: '#ffffff',   // fundo de caixas
    },
    text: {
      primary: '#1f1f1f',
      secondary: '#666',
    },
  },
  typography: {
    fontFamily: ['"Roboto"', 'sans-serif'].join(','),
    h6: {
      fontWeight: 600,
      fontSize: '1.1rem',
      color: '#1f1f1f',
    },
    button: {
      fontWeight: 700,
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiTextField: {
  styleOverrides: {
    root: {
      '& .MuiInputBase-root': {
        backgroundColor: '#fcf2f2ff', // campo sempre com fundo branco
        borderRadius: 4,
      },
      '& .MuiInputBase-input': {
        color: '#1f1f1f', // texto escuro
      },
      '& label': {
        color: '#888',
      },
      '& label.Mui-focused': {
        color: '#f78b00', // cor do label quando em foco
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ccc',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#999',
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#f78b00', // cor da borda ao focar
      },
    },
  },
},

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: '2rem',
          paddingBottom: '2rem',
        },
      },
    },
  },
});

export default theme;
